import { Spin } from 'antd';
import PageLayout from '@components/layout/PageLayout';
import { useOattNspCoreInfoList } from '@hooks/useOattNspCoreInfo';
import { OattNspCoreInfoPanel } from './OattNspCoreInfoPanel';
import styles from './OattNspCoreInfoPage.module.css';

type OattNspCoreInfoPageProps = {
    readOnly?: boolean;
};

const OattNspCoreInfoPage = ({ readOnly = false }: OattNspCoreInfoPageProps) => {
    const { data, loading, refetch } = useOattNspCoreInfoList();

    return (
        <PageLayout title="OATT NSP Core Info">
            {loading ? (
                <Spin />
            ) : (
                <div className={styles.entryList} data-testid="entry-list">
                    {data.map((entry) => (
                        <div
                            key={`oatt-nsp-${entry.oatt_nsp_core_info_id}`}
                            className={styles.entryCard}
                            data-testid="nsp-core-info-entry"
                            data-entry-type={entry.entry_type}
                        >
                            <div className={styles.panelBody}>
                                <OattNspCoreInfoPanel entry={entry} onSaved={refetch} readOnly={readOnly} />
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </PageLayout>
    );
};

export default OattNspCoreInfoPage;
